<template>
<v-app>
  <div id="app" :class="routeName">
    <v-toolbar flat height="100" class="orange-bg pullUp" v-if="pageTitle!='How to enter'">
      <v-img :src="logoImage" contain height="80" max-width="80" @click="takeMeHome" class="hover"></v-img>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat to="/">Home</v-btn>
        <v-btn flat to="/terms">T&amp;CS</v-btn>
        <v-btn flat to="/faq">FAQS</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer =! drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>

      <v-navigation-drawer
      v-model="drawer"
      absolute
      fixed
      class="orange-bg"
    >
    <v-btn flat block to="/">Home</v-btn>
    <v-btn flat block to="/terms">T&amp;CS</v-btn>
    <v-btn flat block to="/faq">FAQS</v-btn>

      <v-divider></v-divider>
    </v-navigation-drawer>

      <v-img :src="mobileLockup" contain class="hidden-md-and-up" v-if="pageTitle!='How to enter'"></v-img>

      <v-img :src="lockupGradient" cover height="440" class="hidden-sm-and-down" v-if="pageTitle!='How to enter'">
        <v-img :src="lockupBackground" contain position="center top" min-height="440">
          <v-img :src="fallingSnow" cover max-height="440" max-width="1900" style="margin:0 auto">
            <v-img :src="laplandSign" contain height="440" position="center -70px">
              <v-img :src="postcardStack" max-height="480" contain position="left" class="postcard-stack">
                <v-img :src="asdaLogo" max-height="96" contain position="right" class="asda-logo"></v-img>
                <v-img :src="ovenMitts" contain max-height="360" position="right" style="margin-top:34px;" class="hidden-md-and-down oven-mitts-desktop"></v-img>     
              </v-img>
            </v-img>
          </v-img>
        </v-img>
      </v-img>

      <!-- v-img :src="ovenMitts" contain max-height="360" position="right" style="margin-top:-360px; margin-right:140px;" class="hidden-md-and-down oven-mitts-desktop"></!-->
      <v-img :src="ovenMitts" contain max-height="162" position="right" style="margin-top:-162px;" class="hidden-lg-and-up oven-mitts-mobile" v-if="pageTitle!='How to enter'"></v-img>
      <!-- v-img :src="ovenMitts" contain max-height="80" position="right" style="margin-top:-80px;" class="hidden-sm-and-up" v-if="pageTitle!='How to enter'"></!-- -->
      
      <v-layout row wrap justify-center v-if="pageTitle!='How to enter'">
        <v-flex xs12>
          <h1 class="orange-bg text-center">{{pageTitle}}</h1>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center v-if="pageTitle!='How to enter'">
        <v-flex xl4 lg6 md8 xs10 class="main">
          <component v-bind:is="currentComponent" v-bind:isAndroid="isAndroid" v-bind:isMobile="isMobile"></component>
        </v-flex>
      </v-layout>
      <component v-bind:is="currentComponent" v-else></component>
    </v-content>
    <v-footer class="orange-bg" height="auto" v-if="pageTitle!='How to enter'">
      <v-layout row wrap justify-center>
        <v-flex xl4 lg6 md8 xs10 v-html="shortTermsData">
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
  </v-app>
</template>

<script>
import Soon from './components/Soon.vue'

export default {
  beforeMount() {
    this.axios.get('/data/shortTerms.html').then((response)=>{
      this.shortTermsData = response.data
    });
    this.axios.get('/api/getSiteStatus').then((response)=>{
      console.log(response)
      if(response.data.success) {
        this.state = response.data.payload.stateCode
      }
    }).catch((error)=>{
      this.error = error
    });
    if(window.location.origin=="http://localhost:8080"|| window.location.origin =="https://staging.mccainlapland.promonow.io") {
      this.state = 5
    }
  },
  name: 'app',
  components: {
    Soon
  },
  data: () => ({
    logoImage : {src:require('@/assets/logo.png')},
    lockupBackground : {src:require('./assets/Header/trees.png')},
    lockupGradient: {src:require('./assets/Header/gradient.png')},
    laplandSign: {src:require('./assets/Header/lapland-sign.png')},
    ovenMitts: {src:require('./assets/Header/mitts.png')},
    asdaLogo: {src:require('./assets/Header/asda.png')},
    fallingSnow: {src:require('./assets/Header/snow.png')},
    postcardStack: {src:require('./assets/Header/postcards.png')},
    mobileLockup: {src:require('./assets/mobile-lockup.png')},
    shortTermsData: '',
    state: 2,
    currentComponent : 'router-view',
    pageTitle: '',
    error: '',
    drawer:false,
    routeName: 'home',
    isAndroid : navigator.userAgent.toLowerCase().indexOf("android") > -1,
    isMobile : navigator.userAgent.toLowerCase().indexOf("mobile") > -1
  }),
  mounted() {
    this.setCurrentComponent();
    this.routeName = this.$router.currentRoute.fullPath.substring(1)
    this.$nextTick(() => {
      setTimeout(function() {
        this.$scrollTo('.pullUp', 1000, { offset: -80 })
      }.bind(this), 1500)
    });
    console.log(this.state);
  },
  methods: {
    setCurrentComponent: function () {
      if(this.state == 1 && ( this.$router.currentRoute.path!='/terms' && this.$router.currentRoute.path!='/faq' && this.$router.currentRoute.path!='/privacy' && this.$router.currentRoute.path!='/how')  ) {
        this.currentComponent = 'Soon'
        this.pageTitle = 'coming soon'
      }else{
        this.currentComponent = 'router-view'
        this.pageTitle = this.$router.currentRoute.name
      }
    },
    takeMeHome: function() {
      this.$router.push('/');
    }
  },
  watch: {
    $route:function() {
      if(this.state == 1 && ( this.$router.currentRoute.path!='/terms' && this.$router.currentRoute.path!='/faq' && this.$router.currentRoute.path!='/privacy' && this.$router.currentRoute.path!='/how')  ) {
        this.currentComponent = 'Soon'
        this.pageTitle = 'coming soon'
      }else{
        this.currentComponent = 'router-view'
        this.pageTitle = this.$router.currentRoute.name
        this.routeName = this.$router.currentRoute.fullPath.substring(1)
      }
      console.log(this.routeName = this.$router.currentRoute.fullPath.substring(1));
    }
  }
}
</script>

